// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._7L3D4L8ux{width:100%}.ZwJPlljsx{}._2K85VkPBx{box-sizing:border-box}._1TqxjnHDx{display:flex;flex:0 1 auto;flex-direction:column;overflow:hidden}.iPAuba6tx{font-size:12px;flex-wrap:nowrap}.iPAuba6tx ._2K85VkPBx{flex:0 0 28px}._5dhUG7qyx{font-size:12px}._5dhUG7qyx .ZwJPlljsx{font-size:14px}._5dhUG7qyx ._2K85VkPBx{flex:0 0 38px}.Lg4pBjkYx{font-size:14px}.Lg4pBjkYx .ZwJPlljsx{font-size:16px}.Lg4pBjkYx ._2K85VkPBx{flex:0 0 53px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"grid": "_7L3D4L8ux",
	"name": "ZwJPlljsx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"img": "_2K85VkPBx",
	"data": "_1TqxjnHDx",
	"small": "iPAuba6tx",
	"medium": "_5dhUG7qyx",
	"large": "Lg4pBjkYx"
};
module.exports = exports;
